import React, { useState, useEffect,useCallback } from "react";
import { Container, Col, Row, Button, Dropdown, Form } from "react-bootstrap";
import { Image } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import * as vacanciesApi from "../../api/vacanciesApi"
import { useSignalAbort } from "../../api/useSignalAbort";
import { Spinner } from 'react-bootstrap';
import { handleApiErrors } from '../../api/handleApiErrors';

function CurrentJobOpening ({ job }) {
  const navigate = useNavigate()
  const abortConstants = useSignalAbort()
  const [Industry, setIndustry] = useState([])
  const [IndustrySelect, setIndustrySelect] = useState(0)
  const [JobOpening, setJobOpening] = useState([])
  const [selectedItem, setSelectedItem] = useState("All Departments");
  const [isLoading, setIsLoading] = useState({})

  const getAllData = useCallback((abortToken) => {
    getAllDepartments(abortToken);
    getByCriteria(0, abortToken);
  }, []);

  useEffect(() => {
    getAllData(abortConstants.controllerConfig);

    // return () => {
    //   // Cleanup logic if needed
    //   abortConstants.controller.abort();
    // };
  }, [getAllData]);

  //AllDepartments
  const getAllDepartments = async (abortToken) => {
    try {
      const result = await vacanciesApi.getAllDepartments(abortToken);
      console.log(result?.data?.Industry);
      setIndustry(result?.data?.Industry);
    } catch (error) {
      handleApiErrors(error, 'AllDepartments', 'alldepartments_response', 'alldepartments_timeout', 'alldepartments_request', setIsLoading)
    }
  };

  //JobByCriteria
  const getByCriteria = async (id, abortToken) => {
    console.log(id);
    try {
      const result = await vacanciesApi.getByCriteria(id, abortToken);
      console.log(result?.data?.Job);
      setJobOpening(result?.data?.Job);
    } catch (error) {
      handleApiErrors(error, 'JobByCriteria', 'jobByCriteria_response', 'jobByCriteria_timeout', 'jobByCriteria_request', setIsLoading)
    }
  };

   const handleDepartmentselect = (e) => {
    setIndustrySelect(e.target.value);
    setSelectedItem(e.target.value); // Update selected item
    console.log(IndustrySelect);
  };
  
  const handleReadMoreClick = (job) => {
    navigate("/ReadMore", { state: { responsibility: job } });
    window.scrollTo(0, 0); // Scroll to the top
    // window.location.reload(); // Refresh the page
  };
  


  const handleSelect = (eventKey, value) => {
    console.log(eventKey);
    setIndustrySelect(value);
    getByCriteria(value, abortConstants.controllerConfig);
    setSelectedItem(eventKey); // Update selected item
  };

  const CustomDropdownItem = ({ eventKey, children, value }) => (
    <Dropdown.Item eventKey={eventKey} onClick={() => handleSelect(eventKey, value)}>
      {children}
    </Dropdown.Item>
  );

  const renderLoading = (item) => {
    if (isLoading[`${item}_response`] || isLoading[`${item}_request`] || isLoading[`${item}_timeout`] ) {
      return true
    }
    else {
      return false
    }
  }

  //Styles
  const captionTextStyle = {
    fontSize: "2rem",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    color: "#2855A1",
    textAlign:'center',
    marginBottom:'50px'
  };

  const captionTextStyle2 = {
    fontSize: "2rem",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    color: "black",
    textAlign:'center',
  };

  const captionStyle = {
    textAlign: "center",
    boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.1)",
    borderRadius: "10px",
    border: "none",
    backgroundColor: "#F7F9FF",
    padding: "2px",
    height:'400px',
    overflow:'auto'
  };


  const captionTextStyleCard2 = {
    fontSize: "14px",
    color: "black",
    textAlign: "left",
    // marginBottom: "2rem",
  };


  const captionTextStyle3 = {
    fontSize: "1.1rem",
    textOverflow: "ellipsis",
    color: "black",
    // textAlign: "left",
    lineHeight: "2.5",
    marginBottom: "2rem",
    // overflow: 'auto'
  };

  const imageStyle = {
    marginBottom: "5px",
    marginTop: "5px",
    width: "60px",
    objectFit: "cover",
    filter: "opacity(3) brightness(1)",
  };

  const captionTextStyleicon = {
    fontSize: "15px",
    color: "black",
    textAlign: "left",
    marginBottom: "2rem",
    marginTop: "15px",
  };
  const imageStyleicon = {
    marginBottom: "2rem",
    width: "15px",
    height:'15px',
    objectFit: "cover",
    marginTop: "15px",
    filter: "opacity(3) brightness(1)",
  };
  const captionTextStyleP = {
    fontSize: '1.1rem', 
    width:'100%' ,
    textAlign:'center',
    lineHeight: "2",
    fontWeight: 700,
    marginBottom:'30px'
  }
  const buttonStyle = {
    fontSize: "12px",
    fontWeight: 600,
    padding: "10px",
    border: "none",
    backgroundColor: "#2855A1",
    color:"White",
    // backgroundColor: isHovered ? "#F7F9FF" : "#2855A1",
    // color: isHovered ? "black" : "White",
    // transition:"background-color 0.5s ease-in-out, color 0.5s ease-in-out, transform 0.3s",
    // transform: isHovered ? "translateX(10px)" : "translateX(0)",
  };
  const responsiveDropdownStyle = {
    width: "180px",
    height: "40px",
    borderRadius: "10px",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px",
    fontWeight: 600,
    color: "black",
    backgroundColor: "white",
  };

  return (
    <Container fluid style={{ marginBottom: "10px", height: "auto" }}>
      <Container
        className=" align-items-center justify-content-center"
        style={{ marginTop: "30px", marginBottom: "10px" }}
      >
        <h1 style={captionTextStyle}>
          {" "}
          Current
          <span style={captionTextStyle2}> Job Openings </span>
        </h1>
        <h2 className="text-lg" style={captionTextStyleP}>
          Step into a realm of opportunities with our comprehensive job
          listings. Each role is chosen to suit your skills and fuel your career
          growth. Your future starts here.{" "}
        </h2>
      </Container>
      <Form>
        <Container style={{ padding: "2px", marginTop: "10px" }}>
          <div className="justify-content-center">
            <Col
              xs={12}
              md={12}
              lg={12}
              sm={12}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Dropdown
                name="IndustryName"
                value={selectedItem}
                onChange={handleDepartmentselect}
              >
                <Dropdown.Toggle
                  variant="outline-primary"
                  id="dropdown-basic"
                  style={responsiveDropdownStyle}
                >
                  {selectedItem}
                </Dropdown.Toggle>

                <Dropdown.Menu style={{ width: "180px", textAlign: "left" }}>
                {Industry ? (
                    Industry.length !== 0 ? (
                      Industry.map((item) => (
                        <CustomDropdownItem
                          key={item.IndustryName}
                          eventKey={item.IndustryName}
                          value={item.IndustryId}
                        >
                          {item.IndustryName}
                        </CustomDropdownItem>
                      ))
                    ) : (
                      <h4 style={{ textAlign: "center" }}>No Data</h4>
                    )
                  ) : (
                    renderLoading("alldepartments") && (
                      <h4 style={{ textAlign: "center" }}>No Data</h4>
                    )
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </Col>
          </div>
          <div style={{ marginTop: "50px", textAlign: "center" }}>
          {JobOpening ? (
                  <>
                  {JobOpening.length !== 0 ? (
             
              <Row className="justify-content-center">
                {JobOpening?.map((job) => (
                  <Col
                    xs={12}
                    md={9}
                    lg={5}
                    sm={6}
                    className="mb-4"
                    key={job.JobId}
                  >
                    <div className="card" style={captionStyle}>
                      <div className="card-body">
                        {/* // Image Company Logo // */}
                        <Row className="align-items-start">
                          <Col xs={12} md={2} lg={2} sm={2}>
                            {job.CompanyLogo ? (
                              <Image
                                src={`${process.env.REACT_APP_BASE_URL}${job.CompanyLogo}`}
                                className="rounded-circle mb-3"
                                alt=""
                                style={imageStyle}
                              />
                            ) : (
                              <p>No company logo available.</p>
                            )}
                          </Col>

                          <Col xs={12} md={10} lg={10} sm={6}>
                            <h3 className="caption-text-style-card">
                              {job.Title}
                            </h3>
                            <div>
                              <Row>
                                <Col xs={12} md={6} lg={6} sm={3}>
                                  <h4 className="caption-text-style-card2">
                                    {job.CompanyName}
                                  </h4>
                                </Col>
                                <Col xs={12} md={6} lg={6} sm={3}>
                                  <h5 className="caption-text-style-card3">
                                    JobCode: {job.JobCode}
                                  </h5>
                                </Col>
                              </Row>
                            </div>
                          </Col>
                        </Row>

                        {/* //Fulltime Year Location // */}
                        <div className="d-flex align-items-center flex-wrap">
                          <Image
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/images/fulltime.png"
                            }
                            alt=""
                            style={{
                              ...imageStyleicon,
                              marginRight: "2rem",
                              marginBottom: "1rem",
                            }}
                          />
                          <h4
                            style={{
                              ...captionTextStyleicon,
                              marginRight: "3rem",
                              marginBottom: "1rem",
                              fontSize: "15px",
                            }}
                          >
                            {job.JobTypeName}
                          </h4>

                          <Image
                            src={
                              process.env.PUBLIC_URL + "/assets/images/exp.png"
                            }
                            alt=""
                            style={{
                              ...imageStyleicon,
                              marginRight: "2rem",
                              marginBottom: "1rem",
                            }}
                          />
                          <h4
                            style={{
                              ...captionTextStyleicon,
                              marginRight: "3rem",
                              marginBottom: "1rem",
                              fontSize: "15px",
                            }}
                          >
                            {job.ExpYears} Y
                          </h4>

                          <Image
                            src={
                              process.env.PUBLIC_URL + "/assets/images/loc2.png"
                            }
                            alt=""
                            style={{
                              ...imageStyleicon,
                              marginRight: "2rem",
                              marginBottom: "1rem",
                            }}
                          />
                          <h4
                            style={{
                              ...captionTextStyleicon,
                              marginRight: "3rem",
                              marginBottom: "1rem",
                              fontSize: "15px",
                            }}
                          >
                            {job.Location}
                          </h4>
                        </div>

                        {/* //Responsibilities// */}
                        <div
                          style={{
                            ...captionTextStyle3,
                            width: "100%",
                            textAlign: "justify",
                            marginTop: "1rem",
                          }}
                        >
                          <div
                            style={{
                              marginTop: "1rem",
                              ...captionTextStyleCard2,
                            }}
                          >
                            <h4>Responsibilities :</h4>
                          </div>

                          {/* //Pragraphs// */}
                          <div>
                            <p
                              dangerouslySetInnerHTML={{
                                __html: job.Responsibility.slice(0, 20),
                              }}
                            />
                            {job.Responsibility && (
                              <button
                                className="btn btn-link"
                                onClick={() => handleReadMoreClick(job)}
                              >
                                Read More...
                              </button>
                            )}
                          </div>
                        </div>
                        {/* //Button// */}
                        <div className="d-flex mt-auto justify-content-end">
                          <Button
                            className="mt-1 mt-md-1 mt-lg-1"
                            size="lg"
                            active
                            style={buttonStyle}
                            onClick={() => {
                              window.location.href = `/CandidateApply/${job.JobCode}`;
                            }}
                            // onClick={() =>
                            //   navigate(`/CandidateApply/${job.JobCode}`)
                            // }
                          >
                            &nbsp;&nbsp; Apply &nbsp;&nbsp;
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
              ) : (
                <div style={{ height: '350px', display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '15px'  }}>
                No data
              </div>
                )}
             </>
                ) : (
                  <>
                    {renderLoading("JobOpening") || (JobOpening===null) ? (
                      <div style={{ height: '350px', display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '15px', fontSize:'20px', fontWeight:600  }}>
                        No data                        
                        </div>
                    ) : (
                      <div style={{ height: '350px', display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '15px'  }}>
                        <Spinner animation="border" role="status" style={{ color: '#2855A1' }} />
                      </div>
                    )}
                  </>
                )}
          </div>
        </Container>
      </Form>
    </Container>
  );
};
export default CurrentJobOpening;
